import { render } from "./FormPabrik.vue?vue&type=template&id=8e29297c"
import script from "./FormPabrik.vue?vue&type=script&lang=js"
export * from "./FormPabrik.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__